import React, { Component } from 'react';
import { Slider } from '@mui/material';
import { Big3Common, bootstrap } from '../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class GoodsFilter extends Component {
    static displayName = GoodsFilter.name;
    constructor(props) {
        super(props);
        this.state = {
            value: [this.Price.Start, this.Price.End],
            order_by: "reg_dt",
            display: "all"

        };
        this.GoodsFilterRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleRadio_Change = this.handleRadio_Change.bind(this);
        this.handleClear_Click = this.handleClear_Click.bind(this);
        this.handleSearch_Click = this.handleSearch_Click.bind(this);
    }
    Price = {
        Start: 10000,
        End: 1000000
    }
    //초기화
    componentDidMount() {
    }
    handleChange(event, newValue) {
        this.setState({ value: newValue });
        this.MoneyText();
    };
    MoneyText() {
        if (this.state.value.length > 0) {
            let Values = this.state.value;
            let StartMoney = Big3Common.Util.Money(Values[0]);
            let EndMoney = Big3Common.Util.Money(Values[1]);
            return (
                <label className="form-label">가격범위({`${StartMoney}원 ~ ${EndMoney}원`})</label>
                )
        }
    }
    handleRadio_Change(event) {
        let name = event.target.name;
        let value = event.target.value;
        this.setState({ [name]: value });
        return false;
    }
    handleClear_Click() {
        this.setState({
            value: [this.Price.Start, this.Price.End],
            order_by: "reg_dt",
            display: "all"
        });
        return false;
    }
    handleSearch_Click(event) {

        if (this.props.CallBack !== undefined) {
            this.props.CallBack({
                Order_By: this.state.order_by,
                Display: this.state.display,
                Start_Price: this.state.value[0],
                End_Price: this.state.value[1]
            });
        }
        Big3Common.ModalClose(bootstrap, this.props.id);
        event.preventDefault();
    }
    render() {
        let MoneyText = this.MoneyText();
        return (
            <div ref={this.GoodsFilterRef } className="modal fade" tabIndex="-1" style={{ zIndex: this.props.zIndex === undefined ? 2000 : this.props.zIndex }} id={this.props.id} data-bs-keyboard="false" data-bs-backdrop="static">
                <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content ordertype_modal">
                        <div className="modal-body text-center ">
                            <div className="desc ordertype_modal_in">
                                <div className="modal_title">필터</div>
                            </div>
                            <div className="category_slectbox">
                                <div className="title">정렬</div>
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="radio"
                                        name="order_by"
                                        value='reg_dt'
                                        checked={this.state.order_by ==="reg_dt" ? "checked" : ""}
                                        onChange={this.handleRadio_Change}
                                    />
                                    <label className="form-check-label">
                                        최신순
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="radio"
                                        name="order_by"
                                        value='view_cnt'
                                        checked={this.state.order_by === "view_cnt" ? "checked" : ""}
                                        onChange={this.handleRadio_Change}
                                    />
                                    <label className="form-check-label">
                                        인기순
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="radio"
                                        name="order_by"
                                        value='price_low'
                                        checked={this.state.order_by === "price_low" ? "checked" : ""}
                                        onChange={this.handleRadio_Change}
                                    />
                                    <label className="form-check-label">
                                        가격 낮은순
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="radio"
                                        name="order_by"
                                        value='price_high'
                                        checked={this.state.order_by === "price_high" ? "checked" : ""}
                                        onChange={this.handleRadio_Change}
                                    />
                                    <label className="form-check-label">
                                        가격 높은순
                                    </label>
                                </div>

                            </div>
                            <div className="category_slectbox">
                                <div className="title">노출</div>
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="radio"
                                        name="display"
                                        value='all'
                                        checked={this.state.display === "all" ? "checked" : ""}
                                        onChange={this.handleRadio_Change}
                                    />
                                    <label className="form-check-label">
                                        전체 보기
                                    </label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input"
                                        type="radio"
                                        name="display"
                                        value='retail_grup'
                                        checked={this.state.display === "retail_grup" ? "checked" : ""}
                                        onChange={this.handleRadio_Change}
                                    />
                                    <label className="form-check-label">
                                        거래처 보기
                                    </label>
                                </div>

                            </div>
                            <div className="category_slectbox">
                                <div className="title">가격</div>
                                <div className="range_box">
                                    <Slider
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        valueLabelDisplay="auto"
                                        step={10000}
                                        min={10000}
                                        max={1000000}
                                    />
                                    {MoneyText}
                                </div>
                            </div>
                            <div className="ok_btn_box">
                                <button onClick={this.handleClear_Click}>초기화</button>
                                <button onClick={this.handleSearch_Click }>결과보기</button>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
